module.exports = __webpack_public_path__ + "img/plumbing-repair-03-med.44ac6aa2.jpg";